<template>
  <v-app id="inspire">
    <v-content>
      <v-container v-if="!authenticated" class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-0">
              <v-toolbar :color="$vuetify.theme.dark ? 'light' : 'white'" flat>
                <v-toolbar-title>{{ $t("form.login.title") }}</v-toolbar-title>
                <div class="flex-grow-1"></div>
                <language-switcher/>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    outlined
                    autocomplete="username"
                    v-model="email"
                    :error-messages="emailErrors"
                    :label="$t('form.login.email')"
                    id="email"
                    append-icon="fa-user"
                    required
                    @input="$v.email.$touch()"
                    @blur="$v.email.$touch()"
                    @keyup.enter="submit"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    v-model="password"
                    :error-messages="passwordsErrors"
                    :label="$t('form.login.password')"
                    autocomplete="current-password"
                    id="password"
                    required
                    name="password"
                    append-icon="fa-key"
                    type="password"
                    :hide-details="!passwordsErrors.length"
                    @keyup.enter="submit"
                  ></v-text-field>
                  <v-alert outlined dense class="my-2" v-if="errorMessage != ''" type="error">
                    {{ errorMessage }}
                  </v-alert>
                  <router-link :to="{ name: 'password-recovery'}">
                    {{ $t("form.login.forgot") }}
                  </router-link>
                </v-form>
                <v-divider class="mt-4 "></v-divider>
              </v-card-text>
              <v-card-actions>
                <div class="ml-2 flex-grow-1"></div>
                <v-btn
                  :disabled="isFetching"
                  :loading="isFetching"
                  elevation="0"
                  class="mr-2 mb-2"
                  min-width="100"
                  color="primary"
                  @click="submit"
                  @keyup.enter="submit"
                >
                  {{ $t("form.login.login") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { mapFields } from "vuex-map-fields";
import { mapState } from "vuex";
import LanguageSwitcher from "@/components/common/LanguageSwitcher";

export default {
  components: {LanguageSwitcher},
  data: () => ({}),
  validations: {
    email: { required, email },
    password: { required },
  },

  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email &&
        errors.push(this.$t("form.validationErrors.email_not_valid")); //this.$t('form.validationErrors.email_required')
      !this.$v.email.required &&
        errors.push(this.$t("form.validationErrors.email_required"));
      return errors;
    },
    passwordsErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required &&
        errors.push(this.$t("form.validationErrors.password_required"));
      return errors;
    },
    ...mapFields("auth", [
      "email",
      "password",
      "errorMessage",
      "authenticated",
    ]),
    ...mapState("auth", ["isFetching"]),
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$store.dispatch("auth/login").then(() => {
        if (this.authenticated) {
          //
          if(this.$route.query.goto && this.$route.query.goto==='back'){
            this.$router.go(-1)
          } else {
            this.$router.push({name: "home"});
          }
        }
      });
    },
  },
};
</script>
